import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../styles/icons/logo.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: '#020203',
    className: null,
};

const FormArrow = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="16.62px"
        height="10px"
        viewBox="0 0 16.62 10"
        className={classNames([styles.container, { [className]: className !== null }])}
        xmlSpace="preserve"
    >
        <g>
            <path
                fill={color}
                d="M16.18,4.13c0.13,0.13,0.24,0.28,0.32,0.44c0.08,0.16,0.12,0.3,0.12,0.44c0,0.15-0.04,0.29-0.11,0.44
		c-0.08,0.15-0.18,0.3-0.32,0.44l-3.3,3.32c-0.18,0.19-0.36,0.33-0.53,0.41C12.17,9.7,12,9.75,11.83,9.75c-0.3,0-0.54-0.1-0.73-0.3
		c-0.18-0.2-0.27-0.47-0.27-0.81c0-0.22,0.06-0.55,0.19-0.98s0.19-0.74,0.19-0.93c0-0.22-0.07-0.38-0.21-0.5s-0.34-0.17-0.59-0.17
		c-0.33,0-0.6,0.08-0.81,0.24c-0.21,0.16-0.4,0.41-0.57,0.77l-0.76,1.6C8.04,9.13,7.78,9.47,7.5,9.68C7.21,9.89,6.87,10,6.46,10
		H1.33c-0.45,0-0.79-0.1-1.01-0.31S0,9.16,0,8.72c0-0.1,0.01-0.21,0.03-0.32c0.02-0.11,0.05-0.23,0.1-0.37l0.85-2.56
		C1,5.39,1.02,5.3,1.03,5.21c0.01-0.09,0.02-0.17,0.02-0.25c0-0.08-0.01-0.16-0.02-0.23C1.02,4.67,1,4.6,0.98,4.54L0.13,1.98
		c-0.04-0.12-0.07-0.24-0.1-0.35C0.01,1.52,0,1.4,0,1.29c0-0.43,0.11-0.75,0.33-0.97S0.89,0,1.33,0h5.13C6.87,0,7.21,0.11,7.5,0.33
		c0.28,0.22,0.54,0.56,0.77,1.03l0.76,1.6C9.2,3.33,9.4,3.59,9.61,3.74c0.21,0.15,0.48,0.22,0.82,0.22c0.25,0,0.44-0.06,0.58-0.18
		c0.14-0.12,0.2-0.28,0.2-0.49c0-0.19-0.06-0.51-0.19-0.94s-0.19-0.76-0.19-0.99c0-0.33,0.09-0.6,0.27-0.8
		c0.18-0.2,0.42-0.3,0.73-0.3c0.17,0,0.34,0.05,0.52,0.14s0.35,0.23,0.53,0.41L16.18,4.13z"
            />
        </g>
    </svg>
);

FormArrow.propTypes = propTypes;
FormArrow.defaultProps = defaultProps;

export default FormArrow;
